
import initialState from '../../../../store/initialState';
import * as forecastTypes from '../services/forecastActionType';

const types = {...forecastTypes};

const forecastReducer = (state = initialState.forecastReducer, action) => {
        switch (action.type) {
        // Forecast Reports Tab (Pagination) - start
        case types.FETCH_FORECAST_REPORTS_TAB_REQUEST:
            return { ...state, isForecastLoading: true };
        case types.FETCH_FORECAST_REPORTS_TAB_SUCCESS:
            return { 
                ...state, 
                isForecastLoading: false, 
                reportsTabData: action.payload?.values.listForecastingDemandReportsData || [],
                reportsTabDataTotal: action.payload?.values.recordsTotal || 0,
            };
        case types.FETCH_FORECAST_REPORTS_TAB_FAILURE:
            return { 
                ...state, 
                isForecastLoading: false, 
                reportsTabData: [],
                reportsTabDataTotal: 0,
            };
        // Forecast Reports Tab (Pagination) - end

        // Delete Forecast Report - start
        case types.DELETE_FORECAST_REPORTS_REQUEST:
            return { ...state, isForecastLoading: true };
        case types.DELETE_FORECAST_REPORTS_SUCCESS:
            return { ...state, isForecastLoading: false };
        case types.DELETE_FORECAST_REPORTS_FAILURE:
            return { ...state, isForecastLoading: false };
        // Delete Forecast Report - end

        // Notes Edit - start
        case types.FETCH_FORECAST_NOTES_EDIT_REQUEST:
            return { ...state, isForecastLoading: true };
        case types.FETCH_FORECAST_NOTES_EDIT_SUCCESS:
            return { 
                ...state,
                isForecastLoading: false,
                notesEditData: action.payload?.values || {},
            };
        case types.FETCH_FORECAST_NOTES_EDIT_FAILURE:
            return { 
                ...state,   
                isForecastLoading: false,
                notesEditData: {},
            };
        // Notes Edit - end

        // Notes Save - start
        case types.FETCH_FORECAST_NOTES_SAVE_REQUEST:
            return { ...state, 
                isForecastLoading: true,
                notesSaveSuccess: false 
            };
        case types.FETCH_FORECAST_NOTES_SAVE_SUCCESS:
            return { 
                ...state,
                isForecastLoading: false,
                notesEditData: {},
                notesSaveSuccess: true
            };
        case types.FETCH_FORECAST_NOTES_SAVE_FAILURE:
            return { 
                ...state,   
                isForecastLoading: false,
                notesEditData: {},
                notesSaveSuccess: false
            };
        // Notes Save - end

        case types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_REQUEST:
            return { ...state, isLoadingWorklistDropdown: true };
        case types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_SUCCESS:
            return { ...state, isLoadingWorklistDropdown: false, demandDropdowns: action.payload };
        case types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_FAILURE:
            return { ...state, isLoadingWorklistDropdown: false };

        case types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_REQUEST:
            return { ...state, isLoadingDemandData: true };
        case types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_SUCCESS:
            const { keyName, data } = action.payload;
            return { ...state, isLoadingDemandData: false, [keyName]: data };
        case types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_FAILURE:
            return { ...state, isLoadingDemandData: false };

        case types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_REQUEST:
            return { ...state, isLoadingSitePriorityDrillthrough: true, sitePriorityDrillthroughData: [] };
        case types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_SUCCESS:
            return { ...state, isLoadingSitePriorityDrillthrough: false, sitePriorityDrillthroughData: action.payload };
        case types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_FAILURE:
            return { ...state, isLoadingSitePriorityDrillthrough: false };

        case types.GET_FORECAST_DEMAND_PRACTICE_SITE_DRILLTHROUGH_REQUEST:
            return { ...state, isLoadingPracticeSiteDrillThrough: true, practiceSiteDrillThroughData: [] };
        case types.GET_FORECAST_DEMAND_PRACTICE_SITE_DRILLTHROUGH_SUCCESS:
            return { ...state, isLoadingPracticeSiteDrillThrough: false, practiceSiteDrillThroughData: action.payload };
        case types.GET_FORECAST_DEMAND_PRACTICE_SITE_DRILLTHROUGH_FAILURE:
            return { ...state, isLoadingPracticeSiteDrillThrough: false };

        case types.SAVE_FORECASTING_DEMAND_REPORTS_REQUEST:
            return { ...state, isSavingForecastReport: true, saveForecastingDemandSuccess: false  };
        case types.SAVE_FORECASTING_DEMAND_REPORTS_SUCCESS:
            return { ...state, isSavingForecastReport: false, saveForecastingDemandSuccess: true };
        case types.SAVE_FORECASTING_DEMAND_REPORTS_FAILURE:
            return { ...state, isSavingForecastReport: false, saveForecastingDemandSuccess: false };  
            
        // Demand Forecast Dropdown Filters
        case types.FETCH_FORECAST_FILTER_DROPDOWNS_REQUEST:
            return {
                ...state,
                isLoadingForecastDropdowns: true
            };

        case types.FETCH_FORECAST_FILTER_DROPDOWNS_SUCCESS:
            return {
                ...state,
                isLoadingForecastDropdowns: false,
                lstPractices: action.payload.lstPractices || [],
                lstSites: action.payload.lstSites || [],
                lstPriorities: action.payload.lstPriorities || [],
                lstForecastRange: action.payload.lstForecastRange || []
            };

        case types.FETCH_FORECAST_FILTER_DROPDOWNS_FAILURE:
            return {
                ...state,
                isLoadingForecastDropdowns: false
            };

        // Common cases
        case types.UPDATE_FORECAST_REDUCER:
            return { ...state, ...action.payload };

        // Fetch Visuals Data - start
        case types.FETCH_VISUALS_DATA_REQUEST:
            return { ...state, isLoadingVisualsData: true, visualsData: {} };
        case types.FETCH_VISUALS_DATA_SUCCESS:
            return { ...state, isLoadingVisualsData: false, visualsData: action.payload };
        case types.FETCH_VISUALS_DATA_FAILURE:
            return { ...state, isLoadingVisualsData: false, visualsData: {} };
        // Fetch Visuals Data - end

        default:
            return state;
        }
};
export default forecastReducer;